// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { Target } from '../../client';
import theme from '../../styled-components/dark';

const Wrapper = styled.div`
  text-align: center;
  color: ${theme.MatchCardSeparator.text.color};
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 1.3em;
  padding: ${Target.__MOBILE__ ? '20px 0 10px' : '10px 0 10px'};
  transform: translate3d(0, 0, 0);
`;

type PropsType = {
  text?: string | null;
  className?: string;
};

const MatchCardSeparator = ({ text, className }: PropsType) => {
  return <Wrapper className={className}>{text}</Wrapper>;
};

export default React.memo<PropsType>(MatchCardSeparator);
